import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { BranchRequestModel } from "@model/branch.model";
import { GenericApiResponseModel, ResponseModel } from "@model/api.model";


@Injectable({
    providedIn: "root",
})
export class BranchApiService {

    constructor(
        private http: HttpClient
        ) {
    }
    
    getBranchList(model: BranchRequestModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/branch/list', model
        );
    }

}
